import { getProactiveDraftsStore } from "../store/store";
import type { ProactiveDraftsState } from "../store/schema/ProactiveDraftsState";
import createProactiveDraftsStateForKeyMutator from "../actions/createProactiveDraftsStateForKeyMutator";

export function getOrCreateProactiveDraftsViewState(itemId: string | undefined): ProactiveDraftsState | undefined {
    if (itemId) {
        const proactiveDrafts = getProactiveDraftsStore().proactiveDraftsListMap.get(itemId);
        if (proactiveDrafts) {
            return proactiveDrafts;
        }
        createProactiveDraftsStateForKeyMutator(itemId);
        
        // After adding, try to retrieve the state again
        return getProactiveDraftsStore().proactiveDraftsListMap.get(itemId);
    }
    return undefined;
}
